import { useState, useEffect, useContext } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Card from "@mui/material/Card";

import { useNavigate, useParams } from "react-router-dom";
import { DataContext } from "context/dataContext";

// MindPlus components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// MindPlus examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// EditArticle page components
import ProgramInfo from "layouts/articles/edit-article/components/ProgramInfo";

function EditArticle() {
  const navigate = useNavigate();
  const params = useParams();
  const [objectid, setObjectId] = useState(null);

  // const editSessions = () => {
  //   navigate(`/programs/sessions-list/${objectid}`);
  // };

  useEffect(() => {
    console.log(params);
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={5} mb={9}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={12}>
            <MDBox mb={2}>
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} lg={6}>
                  <MDTypography variant="h4" fontWeight="medium">
                    Edit Article
                  </MDTypography>
                  <MDBox mt={1}>
                    <MDTypography variant="body2" color="text">
                      Edit & manage the parameters of the article program.
                    </MDTypography>
                  </MDBox>
                </Grid>
                {/* <Grid item xs={12} lg={6} sx={{ textAlign: "right" }}>
                  <MDButton variant="gradient" color="dark" onClick={editSessions}>
                    Edit Sessions
                  </MDButton>
                </Grid> */}
              </Grid>
            </MDBox>
            <MDBox mt={-3}>
              <ProgramInfo />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default EditArticle;
